import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tabActive: 0,
    tabs: [
      {
        permissionId: 0,
        permissionName: "系统主页",
        permissionUrl: "/Main",
      }
    ]
  },
  getters: {
  },
  mutations: {
    addTab(state, tab) {
      state.tabs.push(tab);
      state.tabActive = tab.permissionId;
    }
  },
  actions: {
  },
  modules: {
  }
})
